import React from "react";
import { motion } from "framer-motion";

export const VinylReveal = ({ artwork, artist, track, year, album, mode = "g1", spinning = true, onDark = false, compact = false }) => {
  const isG3 = mode === "g3";
  // G3 = "Raad de artiest" — the primary answer is the ARTIST
  const primary = isG3 ? artist : track;
  const primaryLabel = isG3 ? "Artiest" : null;
  const primaryCls = onDark
    ? `font-bebas ${compact ? "text-2xl sm:text-3xl" : "text-4xl sm:text-6xl"} text-white text-white-shadow uppercase tracking-wide leading-none`
    : "font-display text-3xl sm:text-5xl font-black text-navy leading-tight";
  const secondaryCls = onDark
    ? `font-bebas ${compact ? "text-base sm:text-xl mt-1" : "text-xl sm:text-3xl mt-2"} text-white text-white-shadow uppercase tracking-wide`
    : "font-display text-xl sm:text-3xl text-teal font-bold mt-2";
  const g3SecondaryCls = onDark
    ? "font-bebas text-xl sm:text-2xl text-white text-white-shadow uppercase tracking-wide mt-2"
    : "font-display text-xl sm:text-2xl text-teal font-bold mt-2";
  const labelCls = onDark
    ? "font-bebas text-cream/90 uppercase tracking-widest text-xs sm:text-sm mb-1"
    : "font-bebas text-navy/70 uppercase tracking-widest text-xs sm:text-sm mb-1";
  return (
  <motion.div
    initial={{ y: 60, opacity: 0, scale: 0.9 }}
    animate={{ y: 0, opacity: 1, scale: 1 }}
    transition={{ type: "spring", stiffness: 180, damping: 18 }}
    className={`flex flex-col items-center ${compact ? "gap-2" : "gap-6"}`}
    data-testid="vinyl-reveal"
  >
    <div className={compact ? "relative w-40 h-40" : "relative w-64 h-64 sm:w-80 sm:h-80"}>
      <div className={`vinyl ${spinning ? "animate-spin-slow" : ""}`}>
        <div className="vinyl-label">
          {artwork ? (
            <img src={artwork} alt={primary} className="w-full h-full object-cover" draggable={false} />
          ) : (
            <div className="w-full h-full bg-gradient-to-br from-teal to-coral" />
          )}
        </div>
        <div className="vinyl-hole" />
      </div>
    </div>
    <div className="text-center max-w-xl">
      {isG3 && (
        <div className={labelCls} data-testid="reveal-artist-label">
          Artiest
        </div>
      )}
      <div className={primaryCls} data-testid={isG3 ? "reveal-artist" : "reveal-track"}>
        {primary || "—"}
      </div>
      {isG3 ? (
        <div className={g3SecondaryCls}>
          <span className={onDark ? "opacity-80 text-base" : "opacity-70 text-base"}>Nummer:</span> {track || "—"}
          {album ? <span className={`block text-base sm:text-lg mt-1 ${onDark ? "text-cream/85" : "text-navy/70"}`}><span className="opacity-60">Album:</span> {album}</span> : null}
        </div>
      ) : (
        <div className={secondaryCls} data-testid="reveal-artist">
          {artist || ""}
        </div>
      )}
      {year ? (
        <span className={`inline-block ${compact ? "mt-2 text-base px-4 py-1" : "mt-4 text-lg sm:text-2xl px-5 py-1.5"} bg-gold text-navy font-display font-black rounded-full border-2 border-navy shadow-[0_4px_0_#1E1B4B]`} data-testid="reveal-year">
          {year}
        </span>
      ) : null}
    </div>
  </motion.div>
  );
};
